import { MSerializer, MSerializers, serializerExtensions, SerializerExtensions } from "@legacy-megarax/serializers";
import Decimal from "decimal.js";

export type GeoPoint = {
  latitude: Decimal;
  longitude: Decimal;
};

export const geoPointSerialzier = MSerializers.object<GeoPoint>({
  latitude: MSerializers.decimal,
  longitude: MSerializers.decimal,
});

export const geoPointElasticsearchSerializer: MSerializer<GeoPoint> & SerializerExtensions<GeoPoint> = {
  serialize: (value) => ({
    lat: MSerializers.decimal.serialize(value.latitude),
    lon: MSerializers.decimal.serialize(value.longitude),
  }),
  forceDeserialize: (raw) => ({
    latitude: MSerializers.decimal.forceDeserialize(raw.lat),
    longitude: MSerializers.decimal.forceDeserialize(raw.lon),
  }),
  ...serializerExtensions(),
};
